// The dashboard's summary MEDIAN (robust to a single bad detection), rounded
// to one decimal; null on an empty list. Shared by the Photos folders and the
// Daily Log so both per-day FaceAge summaries agree.
export function median(values: number[]): number | null {
  const sorted = [...values].sort((a, b) => a - b);
  if (sorted.length === 0) return null;
  const mid = Math.floor(sorted.length / 2);
  const upper = sorted[mid] ?? 0;
  const lower = sorted[mid - 1] ?? upper;
  const value = sorted.length % 2 === 1 ? upper : (lower + upper) / 2;
  return Math.round(value * 10) / 10;
}
